/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponidMutationResponse,
  DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponidPathParams,
  DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponidQueryParams,
  DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponid400,
  DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponid401,
  DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponid500,
} from "../../types/individualPaymentEditorsController/DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponid.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { deleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponid } from "../../clients/individualPaymentEditorsController/deleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponid.ts";

export const deleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponidMutationKey =
  () =>
    [
      {
        url: "/api/v1/individualpayment/financial-people/:financialPersonId/coupons/:couponId",
      },
    ] as const;

export type DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponidMutationKey =
  ReturnType<
    typeof deleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponidMutationKey
  >;

export function deleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponidMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const mutationKey =
    deleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponidMutationKey();
  return mutationOptions<
    DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponidMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponid400
      | DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponid401
      | DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponid500
    >,
    {
      financialPersonId: DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponidPathParams["financialPersonId"];
      couponId: DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponidPathParams["couponId"];
      params?: DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponidQueryParams;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ financialPersonId, couponId, params }) => {
      return deleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponid(
        financialPersonId,
        couponId,
        params,
        config,
      );
    },
  });
}

/**
 * @description Desativa o vínculo com justificativa e subtrai o desconto do plano (piso zero). Migrado do legado IndividualPayment/RemoveCoupon. **(Requer Authorization para autenticação)**
 * @summary Remove um cupom aplicado ao plano financeiro (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/financial-people/:financialPersonId/coupons/:couponId}
 */
export function useDeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponid<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponidMutationResponse,
      ResponseErrorConfig<
        | DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponid400
        | DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponid401
        | DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponid500
      >,
      {
        financialPersonId: DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponidPathParams["financialPersonId"];
        couponId: DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponidPathParams["couponId"];
        params?: DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponidQueryParams;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    deleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponidMutationKey();

  const baseOptions =
    deleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponidMutationOptions(
      config,
    ) as UseMutationOptions<
      DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponidMutationResponse,
      ResponseErrorConfig<
        | DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponid400
        | DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponid401
        | DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponid500
      >,
      {
        financialPersonId: DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponidPathParams["financialPersonId"];
        couponId: DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponidPathParams["couponId"];
        params?: DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponidQueryParams;
      },
      TContext
    >;

  return useMutation<
    DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponidMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponid400
      | DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponid401
      | DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponid500
    >,
    {
      financialPersonId: DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponidPathParams["financialPersonId"];
      couponId: DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponidPathParams["couponId"];
      params?: DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponidQueryParams;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponidMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponid400
      | DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponid401
      | DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponid500
    >,
    {
      financialPersonId: DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponidPathParams["financialPersonId"];
      couponId: DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponidPathParams["couponId"];
      params?: DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponidQueryParams;
    },
    TContext
  >;
}
